// src/components/Admin/RutasDidacticasComp/RutasDidacticasForm/RutasDidacticasWizard.jsx

import React, { useState } from "react";
import { Step, Modal} from "semantic-ui-react";
import { RutasDidacticasFormStep1, RutasDidacticasFormStep2 } from "./RutasDidacticasForm";

import "./RutasDidacticasWizard.scss";

/**
 * RutasDidacticasWizard:
 * - Usa un Step.Group para indicar en qué paso estamos
 * - Paso 1: Crear ruta
 * - Paso 2: Seleccionar asistentes
 */
export function RutasDidacticasWizard({
  accessToken,
  teacher,
  onClose,
  onReload,
  forceCreateMode,
}) {
  // Manejo del paso actual
  const [activeStep, setActiveStep] = useState(1);

  // Almacena la información de la ruta recién creada
  const [createdRoute, setCreatedRoute] = useState(null);

  // Función para avanzar de paso
  const goNext = () => setActiveStep((prev) => prev + 1);

  // Función para retroceder de paso (si deseas permitirlo)
  const goBack = () => setActiveStep((prev) => prev - 1);

  // Definición de los steps para Semantic UI
  const steps = [
    { key: "step1", title: "Crear Itinerario", icon: "folder" },
    { key: "step2", title: "Seleccionar Asistentes IA", icon: "users" },
  ];

  // Renderizar contenido según el paso
  const renderContent = () => {
    switch (activeStep) {
      case 1:
        return (
          <RutasDidacticasFormStep1
            accessToken={accessToken}
            teacher={teacher}
            onRouteCreated={(route) => {
              setCreatedRoute(route);
              goNext();
            }}
            onClose={onClose}
            onReload={onReload}
            forceCreateMode={forceCreateMode}
          />
        );
      case 2:
        return (
          <RutasDidacticasFormStep2
            accessToken={accessToken}
            teacher={teacher}
            route={createdRoute}
            onReload={onReload}
            onClose={onClose}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Modal open={true} onClose={onClose} size="large" closeIcon>
      {/* Barra de pasos (wizard) */}
      <div className="wizard-step-group">
        <Step.Group ordered items={steps} activeIndex={activeStep - 1} />
      </div>

      {/* Contenido dinámico según el paso */}
      {renderContent()}
    </Modal>
  );
}
